export enum MathStyle {
  Display = 'D',
  Text = 'T',
  Script = 'S',
  ScriptScript = 'SS',
}

export enum RenderMode {
  Static = 'static',
  Dynamic = 'dynamic',
}

export enum RadicalDegreeAlgorithm {
  OpenType,
  MathML,
}
